import { CropStatusEnum } from '@/common/constants';
import { ContractTypesEnum } from '@/common/constants/contract.types.constants';
import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

export const GeneralSchema = yup.object().shape({
  tax_number: yup.string().required(messages.required),
  farmer_contract_id: yup.string().required(messages.required),
  harvest_type: yup.string().required(messages.required),

  crop_data: yup.string().when('$cropStatus', {
    is: CropStatusEnum.HAS_LAND_MERGE_DATA,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),

  crop_type_id: yup.string().when('$cropStatus', {
    is: CropStatusEnum.NOT_HAS_LAND_MERGE_DATA,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),

  crop_generation_type: yup.string().when('$dealType', {
    is: ContractTypesEnum.STORAGE,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),

  crop_generation_id: yup
    .string()
    .when(['crop_generation_type', '$cropStatus'], {
      is: (crop_generation_type: string, cropStatus: CropStatusEnum) =>
        crop_generation_type === 'SEED' &&
        cropStatus === CropStatusEnum.NOT_HAS_LAND_MERGE_DATA,
      then: () => yup.string().required(messages.required),
      otherwise: () => yup.string().optional(),
    }),
  storage_type: yup.string().when(['crop_generation_type', '$cropStatus'], {
    is: (crop_generation_type: string, cropStatus: CropStatusEnum) =>
      crop_generation_type === 'SEED' &&
      cropStatus === CropStatusEnum.NOT_HAS_LAND_MERGE_DATA,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),
});
